import React from 'react';

import ColorPicker from 'components/colorPicker/ColorPicker';
import { updateAttributeOnDocument } from 'util/pouchActions';

class PouchColorPicker extends React.Component {

  handleChange = (hex) => {
    updateAttributeOnDocument(this.props.meet._id, this.props.document._id, this.props.name, hex);
  }

  render() {
    return (
      <ColorPicker value={this.props.value} onChange={this.handleChange} />
    );
  }
}

export default PouchColorPicker;
